import { Milliseconds } from '@/enums/millisecondsEnum'
import { isDate, isString, isObject } from './is'

function encode(v: string) {
  return encodeURIComponent(v)
}

function decode(v: string) {
  return decodeURIComponent(v)
}

function stringifyValue(v: unknown): string {
  return encode(isObject(v) ? JSON.stringify(v) : '' + v)
}

function getExpiresString(offsetMilliseconds: number) {
  const now = new Date()
  now.setMilliseconds(now.getMilliseconds() + offsetMilliseconds)
  return now.toUTCString()
}

function parseExpiresOptionString(str: string) {
  if (str.trim() === '') {
    return void 0
  }
  const days = str.match(/(\d+)d/)
  const hours = str.match(/(\d+)h/)
  const minutes = str.match(/(\d+)m/)
  const seconds = str.match(/(\d+)s/)

  let milliseconds = 0

  if (days) {
    milliseconds = +days[1] * Milliseconds.IN_DAY
  }

  if (hours) {
    milliseconds += +hours[1] * Milliseconds.IN_HOUR
  }

  if (minutes) {
    milliseconds += +minutes[1] * Milliseconds.IN_MINUTE
  }

  if (seconds) {
    milliseconds += +seconds[1] * 1000
  }
  return (milliseconds && getExpiresString(milliseconds)) || void 0
}

function parseResult(v: string) {
  let res
  try {
    res = JSON.parse(decode(v))
  } catch (e) {
    return v
  }
  return res
}

/**
 * 设置cookie
 * @param key key name
 * @param val value
 * @param opts extra options
 * @returns
 */
export function setCookie(key: string, val: any, opts: CookieOpts = { path: '/' }) {
  key = key.trim()
  if (key === '') {
    return false
  }

  let expires
  if (opts.expires) {
    if (isDate(opts.expires)) {
      expires = opts.expires.toUTCString()
    } else if (isString(opts.expires)) {
      expires = parseExpiresOptionString(opts.expires)
    } else {
      expires = Number.isNaN(opts.expires) ? 0 : opts.expires
      expires = (expires && getExpiresString(expires * Milliseconds.IN_DAY)) || void 0
    }
  }

  const keyValue = `${encode(key)}=${stringifyValue(val)}`
  const cookieData = [
    keyValue,
    (expires && `expires=${expires}`) || '',
    (opts.path && `path=${opts.path}`) || '',
    (opts.domain && `domain=${opts.domain}`) || '',
    (opts.samesite && `SameSite=${opts.samesite}`) || '',
    (opts.secure && 'Secure') || '',
  ]

  document.cookie = cookieData.join(';')
  return true
}

/**
 * 获取Cookie值
 * @param key cookie键名
 */
export function getCookie(key: string) {
  if (key.trim() === '') {
    return null
  }

  key = encode(key)
  const matches = document.cookie.match(new RegExp(`(?:^|;+|\\s+)${key}=([^;]*)`))
  let res = matches && matches[1]

  if (res) {
    res = parseResult(res)
  }
  return res
}

/**
 * 获取所有cookie
 */
export function getAllCookie(): Recordable {
  const docCookies = document.cookie
  const cookies = docCookies ? docCookies.split(';') : []
  const result: Recordable = {}

  for (const item of cookies) {
    const [k, v] = item.split('=')
    result[decode(k)] = v && parseResult(v)
  }

  return result
}

/**
 * 判断cookie是否存在
 * @param key cookie键名
 */
export function hasCookie(key: string) {
  return getCookie(key) !== null
}

/**
 * 删除cookie
 * @param key
 */
export function removeCookie(key: string) {
  if (key.trim() === '') {
    return
  }

  setCookie(key, '', { expires: -1 })
}

export default {
  get: (key: string) => getCookie(key),
  set: (key: string, val: any, opts: CookieOpts = {}) => setCookie(key, val, opts),
  getAll: () => getAllCookie(),
  has: (key: string) => hasCookie(key),
  remove: (key: string) => removeCookie(key),
}
